var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 6.475C19.0875 6.0625 14.9 5.85 10.725 5.85C8.25 5.85 5.775 5.975 3.3 6.225L0.75 6.475M7.625 5.2125L7.9 3.575C8.1 2.3875 8.25 1.5 10.3625 1.5H13.6375C15.75 1.5 15.9125 2.4375 16.1 3.5875L16.375 5.2125M20.5625 10.425L19.75 23.0125C19.6125 24.975 19.5 26.5 16.0125 26.5H7.9875C4.5 26.5 4.3875 24.975 4.25 23.0125L3.4375 10.425M9.9125 19.625H14.075M8.875 14.625H15.125",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.be050db97649714ce89e5dee7261f20c.svg";
export { ForwardRef as ReactComponent };